import React, { Component } from 'react'
import { Row,Col,Form,Input } from 'reactstrap'
import { Button } from '../../components/common/common'

export default class Contactform extends Component {
    constructor(){
        super();
        this.state ={
            first_name:'',
            email:'',
            subject:'',
            comments:'',
            errors:{}
        }
     }
    setValue = (event) => {
        const { target: { name, value } } = event
        this.setState({ [name]: value, event: event })
     }
  
     handelSubmit = (e) => {
         const errors = {}
        if(!this.state.first_name){
            errors.first_name = 'First Name field shouldn’t be empty';
        }
        if(!this.state.email){
            errors.email = 'Email field shouldn’t be empty';
        }
        if(!this.state.subject){
            errors.subject = 'Subject field shouldn’t be empty';
        }

        if(errors){
            this.setState({errors:errors})
        }
     }
     
    render() {

        return (
            <Form method="POST" id="contact-form">
                <Input 
                    type='hidden' 
                    name='form-name' 
                    value='contactForm'
                />
                <Row>
                    <Col md="6">
                        <div className="contact-input-type">
                            <div className="form-group contact-text-box">
                                <Input 
                                    name="first_name" 
                                    id="first_name" 
                                    type="text" 
                                    className={`orm-control rounded ${this.state.errors.first_name ? 'error' : ''}`} 
                                    placeholder="First Name" 
                                    onChange={(e) => this.setValue(e)}
                                />
                            </div>
                            <div className="form-group contact-text-box">
                                <Input 
                                    name="email" 
                                    id="email" 
                                    type="email" 
                                    className={`orm-control rounded ${this.state.errors.email ? 'error' : ''}`} 
                                    placeholder="Email" 
                                    onChange={(e) => this.setValue(e)}
                                />
                            </div>
                            <div className="form-group contact-text-box">
                                <Input 
                                    name="subject" 
                                    id="subject" 
                                    type="text" 
                                    className={`orm-control rounded ${this.state.errors.subject ? 'error' : ''}`} 
                                    placeholder="Subject"
                                    onChange={(e) => this.setValue(e)}
                                />
                            </div>
                        
                        </div>
                    </Col >
                    <div className="col-md-6">
                        <div className="form-group contact-text-area">
                            <Input 
                                type="textarea" 
                                name="comments" 
                                id="comments" 
                                rows="4" 
                                className={`rounded ${this.state.errors.subject ? 'error' : ''}`}
                                onChange={(e) => this.setValue(e)}
                                placeholder="Your Message "
                            />
                        </div>
                    </div>
                </Row>
                <Button 
                    divclass="allbutton contact-btn text-right" 
                    btnType="button" 
                    btnClass="btn" 
                    spanHover="Send Message" 
                    btnId="contact-submit" 
                    btnName="Send Message"
                    btnClick={(e) => this.handelSubmit()} />
                </Form>
        )
    }
}
